import React, { useEffect } from "react";
import styled from "styled-components";
import { motion, useAnimation } from "framer-motion";
import settings from "@src/settings";

interface Props {
	toClose?: boolean;
	className?: string;
	onClick?: () => void;
}

const Frame = styled.button`
	width: 3rem;
	height: 35px;
	position: relative;
`;
const Bar = styled(motion.div)`
	width: 100%;
	height: 5px;
	background-color: ${settings.color.main};
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`;

const animation = {
	bar: {
		readyForClose: {
			marginTop: 0,
			transition: {
				type: "spring",
				stiffness: 1000,
				damping: 50,
				mass: 1,
			},
		},
		close: (index: number) => ({
			x: "-50%",
			y: "-50%",
			rotate: index == 0 ? -45 : index == 2 ? 45 : 0,
			opacity: index === 1 ? 0 : 1,
			transition: {
				type: "spring",
				stiffness: 600,
				damping: 100,
				mass: 1,
			},
		}),
		readyForOpen: { rotate: 0 },
		steadyForOpen: { opacity: 1 },
		open: (index: number) => ({
			x: "-50%",
			y: "-50%",
			marginTop: index == 0 ? -15 : index == 2 ? 15 : 0,
		}),
	},
};
const Humburger: React.FC<Props> = (props) => {
	const { toClose, onClick, className } = props;
	const barControl = useAnimation();
	useEffect(() => {
		if (toClose) {
			(async () => {
				await barControl.start("readyForClose");
				barControl.start("close");
			})();
		} else {
			(async () => {
				await barControl.start("readyForOpen");
				barControl.set("steadyForOpen");
				barControl.start("open");
			})();
		}
	}, [toClose]);
	const barTransition = {
		type: "spring",
		stiffness: 200,
		damping: 20,
	};
	return (
		<Frame className={className} onClick={onClick}>
			{new Array(3).fill(null).map((_, index) => (
				<Bar
					initial={!toClose ? "open" : "close"}
					animate={barControl}
					variants={animation.bar}
					custom={index}
					key={index}
					transition={barTransition}
				/>
			))}
		</Frame>
	);
};

export default styled(Humburger)``;
